import { History } from 'history';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { TConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

import { isDashboardEnabled } from '../../../common/helpers/ConfigurationHelpers';
import { BusinessUnit, DashboardTabId } from '../types/DashboardTypes';

import { getFirstBusinessUnit } from './BusinessUnitsHelpers';
import { getDashboardTabConfig } from './TabNavigationHelpers';

/**
 * Navigate to a specific dashboard tab
 */
export const navigateToDashboardTab = (history: History, tabId: DashboardTabId): void => {
	const config = getDashboardTabConfig(tabId);
	history.push(config.path);
};

/**
 * Handle dashboard redirection based on configuration
 */
export const handleDashboardRedirection = (
	history: History,
	configuration: TConfiguration,
	fallbackPath?: string
): void => {
	if (isDashboardEnabled(configuration)) {
		history.replace(RoutesHelper.getAccessibilityDashboardPath());
	} else if (fallbackPath) {
		history.replace(fallbackPath);
	} else {
		history.replace(RoutesHelper.getHomepagePath());
	}
};

/**
 * Navigate to a specific business unit
 */
export const navigateToBusinessUnit = (history: History, unitId: string): void => {
	// Scroll to top immediately before navigation
	window.scrollTo(0, 0);
	history.replace(RoutesHelper.getBusinessUnitDashboardPath(unitId));
};

/**
 * Navigate to first available business unit
 */
export const navigateToFirstBusinessUnit = (
	history: History,
	businessUnits: BusinessUnit[]
): void => {
	const firstUnit = getFirstBusinessUnit(businessUnits);

	if (firstUnit) {
		navigateToBusinessUnit(history, firstUnit);
	}
};
